export default [
  {
    title: 'breadcrumb.balanceReport',
    route: 'balance-report',
    icon: '',
    resource: 'balance-report',
    action: 'read',
  },
]
